import { scaleOrdinal } from 'd3-scale';

// #5F4690,#1D6996,#38A6A5,#0F8554,#73AF48,#EDAD08,#E17C05,#CC503E,#94346E,#6F4070,#994E95,#666666
export const colorScale = scaleOrdinal()
  .domain(['Helfer', 'Fachkraft', 'Spezialist', 'Experte'])
  .range(['#1D6996', '#0F8554', '#EDAD08', '#94346E']);

export function getCircleColor(props) {
  return colorScale(props.qualification);
}

export function getStrokeColor(props) {
  return props.isSelected ? '#111' : colorScale(props.qualification);
}

export function getFillOpacity(props) {
  return props.isSelected || props.isHighlighted ? 0.6 : 0.01;
}

export function getStrokeOpacity(props) {
  return props.isSelected || props.isHighlighted ? 1 : 0.1;
}

export function getStrokeWidth(props) {
  return props.isSelected ? 2 : 1;
}

export function hexToRGB(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
}

export default {
  getCircleColor,
  getFillOpacity,
  getStrokeOpacity,
  getStrokeColor,
  getStrokeWidth,
  hexToRGB,
};
